var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocateWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9944 11.9998C15.9944 14.2115 14.2006 15.9966 11.996 15.9966C9.78341 15.9966 7.99756 14.2036 7.99756 11.9998C7.99756 9.78811 9.79132 8.00296 11.996 8.00296C14.2006 7.99506 15.9944 9.78811 15.9944 11.9998Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3994 11.3997H20.064C19.7637 7.40284 16.5871 4.23539 12.5966 3.93523V2.60032C12.5966 2.26856 12.3279 2 11.996 2C11.6642 2 11.3955 2.26856 11.3955 2.60032V3.92733C7.39708 4.22749 4.22837 7.40284 3.92809 11.3997H2.60055C2.26867 11.3997 2 11.6682 2 12C2 12.3318 2.26867 12.6003 2.60055 12.6003H3.92809C4.22837 16.5972 7.40498 19.7646 11.3955 20.0648V21.3918C11.3955 21.7235 11.6642 21.9921 11.996 21.9921C12.3279 21.9921 12.5966 21.7235 12.5966 21.3918V20.0569C16.595 19.7567 19.7637 16.5814 20.064 12.5924H21.3994C21.7313 12.5924 22 12.3239 22 11.9921C22 11.6682 21.7313 11.3997 21.3994 11.3997ZM11.996 18.8957C8.18728 18.8957 5.09759 15.8073 5.09759 12C5.09759 8.19273 8.18728 5.10427 11.996 5.10427C15.8048 5.10427 18.8945 8.19273 18.8945 12C18.8945 15.8073 15.8048 18.8957 11.996 18.8957Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocateWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locate-white.252991c134452e9cdc7ad1b3cb10e85e.svg";